module.exports = __webpack_public_path__ + "assets/f6c480f15b6a537638b258f9e01fd9e1.png";